import { nativeApplicationVersion, nativeBuildVersion } from "expo-application";
import { Platform } from "react-native";

import { expo } from "../../app.json";

/** The running app's store version and build; web reports the deployed bundle's. */
export function appVersion(): { version: string | null; build: string | null; } {
  if (Platform.OS === "web") {
    return { version: expo.version, build: process.env.EXPO_PUBLIC_WEB_BUILD_NUMBER || "local" };
  }
  return { version: nativeApplicationVersion, build: nativeBuildVersion };
}
